'use strict';

export const URL = "http://www.gmhdobrasil.com.br"


// WEBPACK FOOTER //
// ./src/app/globals.ts